import { useEffect, type RefObject } from 'react';

/**
 * Closes on any mousedown outside the given ref's element. First real
 * extraction of the pattern hand-duplicated in TabBar.tsx (overflow menu,
 * add-panel menu) and ~12 places in flow-studio-designer — those existing
 * call sites are not retrofitted here, this is just the new shared version.
 */
export function useOnClickOutside(ref: RefObject<HTMLElement | null>, onOutside: () => void): void {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current?.contains(e.target as Node)) return;
      onOutside();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [ref, onOutside]);
}
